module.exports = __webpack_public_path__ + "static/img/iwatch_Nike5.ddf5ece4.jpg";